export interface EventTicketType {
    id: number;
    uid: string;
    name: string;
    price: number;
    currencyCode: string;
    description: string;
    tenantId: string;
    free: boolean;
    eventUid: string;
    eventId: number;
    ticketsLimit: number;
    availableTickets: number;
    status: EventTicketStatus;
    /** false: bought by quantity, with no seat to choose (a seated event may carry such types) */
    withSeats?: boolean;
}

export interface TicketTypeAddOn {
    id: number;
    uid: string;
    ticketTypeUid: string;
    name: string;
    description?: string;
    amount: number;
    currencyCode: string;
    active: boolean;
    required: boolean;
    archived: boolean;
}

export interface TicketTypeAddOnSelection {
    uid: string;
    quantity: number;
}


export enum EventTicketStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    SOLD_OUT = 'SOLD_OUT',
  }
